import {logger} from './logger';
import {existsCookie, setCookie, getCookie, deleteCookie} from './cookie';
import {LASTSHOW_IMAGINARY_NAME} from '../constants';

const isStorageSupported = window.localStorage && window.localStorage.getItem && window.localStorage.setItem;

/**
 * Gets item from localStorage
 *
 * @param {string} cname
 */
const getStorageItem = cname => (isStorageSupported ? localStorage.getItem(cname) : null);

/**
 * Sets item into localStorage
 *
 * @param {string} cvalue
 * @param {string} cname
 */
const setStorageItem = (cvalue, cname) => isStorageSupported && localStorage.setItem(cname, cvalue);

/**
 * Check if item exists in localStorage or is available as cookie
 *
 * @param {string} cname
 */
export const itemExists = cname => existsCookie(cname) || !!getStorageItem(cname);

/**
 * Sets item into localStorage and cookies
 *
 * @param {string} cvalue
 * @param {string} cname
 */
export const setItem = (cvalue, cname) => {
  setCookie(cvalue, cname);
  setCookie(cvalue, LASTSHOW_IMAGINARY_NAME);
  setStorageItem(cvalue, cname);
};

/**
 * Looks for data in localStorage and cookies and sync them
 *
 * @param {string} cname
 */
export const syncStorage = cname => {
  const item = getStorageItem(cname);
  const cookie = getCookie(cname);
  if (!item && !cookie) {
    logger(1901, 'Nothing to sync');
    return;
  }

  if (cookie && !item) {
    // sync to localStorage
    logger(1902, 'No cmplastshowcookie in localStorage, sync it from cookie');
    setStorageItem(cookie, cname);
  } else if (!cookie && item) {
    // sync cookie
    logger(1903, 'No cmplastshowcookie, sync it from localStorage');
    setCookie(item, cname);
  } else {
    // sync newer data
    if (parseInt(cookie, 10) < parseInt(item, 10)) {
      logger(1904, 'Newer cmplastshowcookie in localStorage, sync it to cookies');
      deleteCookie(cname);
      setCookie(item, cname);
    } else if (parseInt(cookie, 10) > parseInt(item, 10)) {
      logger(1905, 'Newer cmplastshowcookie in cookies, sync it to localStorage');
      setStorageItem(cookie, cname);
    } else {
      logger(1906, 'cmplastshowcookie is same in both storages, do nothing.');
    }
  }
};

/**
 * Gets item from localStorage and cookies
 *
 * @param {string} cname
 */
export const getItem = cname => getStorageItem(cname) || getCookie(cname);
